import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavBarTeamsComponent } from './nav-bar-teams/nav-bar-teams.component';
import { LIONSComponent } from './lions/lions.component';
import { KINGSComponent } from './kings/kings.component';
import { VIKINGSComponent } from './vikings/vikings.component';
import { WARRIORSComponent } from './warriors/warriors.component';
import { GIANTSComponent } from './giants/giants.component';
import { TeamDetailsComponent } from './team-details/team-details.component';
import { PastStatsComponent } from './past-stats/past-stats.component';
import { NavBarYearsComponent } from './nav-bar-years/nav-bar-years.component';
import { Stats2018Component } from './stats2018/stats2018.component';
import { MostRunsOverallComponent } from './most-runs-overall/most-runs-overall.component';
import { MostWicketOverallComponent } from './most-wicket-overall/most-wicket-overall.component';
import { StatsOverallComponent } from './stats-overall/stats-overall.component';
import { HomeNavBarComponent } from './home-nav-bar/home-nav-bar.component';
import { TEAMSComponent } from './teams/teams.component';
import { ALLTIMEComponent } from './alltime/alltime.component';
import { STATSComponent } from './stats/stats.component';
import { STATS2016Component } from './stats2016/stats2016.component';
import { STATS2017Component } from './stats2017/stats2017.component';
import { HomeComponent } from './home/home.component';
import { HomeFooterComponent } from './home-footer/home-footer.component';

@NgModule({
  declarations: [
    AppComponent,
    NavBarTeamsComponent,
    LIONSComponent,
    KINGSComponent,
    VIKINGSComponent,
    WARRIORSComponent,
    GIANTSComponent,
    TeamDetailsComponent,
    PastStatsComponent,
    NavBarYearsComponent,
    Stats2018Component,
    MostRunsOverallComponent,
    MostWicketOverallComponent,
    StatsOverallComponent,
    HomeNavBarComponent,
    TEAMSComponent,
    ALLTIMEComponent,
    STATSComponent,
    STATS2016Component,
    STATS2017Component,
    HomeComponent,
    HomeFooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
